class PersistentActions {
  constructor() {
    this.initialState = true;
    this.$el = $(document);
    this.selector = '.io-form-actions.persistent';
    this.namespace = '.persistentActions';
  }

  startListening() {
    $(this.selector).length ? this.delegate() : this.undelegate();
    htmx.process(document.body);
  }

  fix() {
    if (this.element.hasClass('fixed')) {
      return;
    }
    this.initialState = false;
    this.element.addClass('fixed');
    this.element.width(this.elementWidth);
    this.element.css('left', this.elementOffset.left);
  }

  unfix() {
    if (!this.element.hasClass('fixed')) {
      return;
    }
    this.initialState = true;
    this.element.removeClass('fixed');
    this.element.width('auto');
  }

  delegate() {
    this.element = $(this.selector);
    this.elementOffset = this.element.offset();
    this.elementWidth = this.element.width();
    this.$el.on(`scroll${this.namespace}`, window, (e) => {
      $(e.target).scrollTop() >= this.elementOffset.top - 10
        ? this.fix()
        : this.unfix();
    });
  }

  undelegate() {
    this.element = null;
    this.$el.off(this.namespace);
    this.initialState = true;
  }
}

module.exports = new PersistentActions();
